/**
 * Domínio do cardápio (app.zapermenu.com.br/{dominio}), na mesma regra da API
 * (StringConversor::slugify): "TCHÊ Assados & Fritos" → "tche-assados-e-fritos".
 *
 * Só se aplica ao que alguém digita ou ao nome de uma loja nova. Domínio já
 * salvo aparece como está, mesmo fora da regra: o link dele funciona hoje.
 */
const semAcento = texto => texto.normalize('NFD').replace(/[̀-ͯ]/g, '');

/** Enquanto digita: troca acento, maiúscula e espaço, e mantém o traço do fim ("meu-"). */
export function limparDominio(valor) {
    return semAcento(String(valor || ''))
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-{2,}/g, '-');
}

/** Domínio pronto, a partir do nome da loja ou do que foi digitado. */
export function slugDominio(valor) {
    return limparDominio(String(valor || '').replace(/&/g, ' e '))
        .replace(/^-+|-+$/g, '');
}
